import { ReactNode, createContext, useContext, useState } from "react";
import DeleteModal from "./DeleteModal";
import { IDriver } from "models/driver";
import BanModal from "./BanModal";
import ActivateModal from "./ActivateModal";

interface IDriverAlertProps {
  showDelete: (driver: IDriver) => void;
  showBan: (driver: IDriver) => void;
  showActivate: (driver: IDriver) => void;
}

export const DriverAlertContext = createContext<IDriverAlertProps>(
  {} as IDriverAlertProps
);

export const useDriverAlertContext = () =>
  useContext<IDriverAlertProps>(DriverAlertContext);

interface IOpen {
  open: boolean;
  driver: IDriver | null;
}

export function DriverAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openDelete, setOpenDelete] = useState<IOpen>({
    open: false,
    driver: null,
  });
  const [openBan, setOpenBan] = useState<IOpen>({ open: false, driver: null });
  const [openActivate, setOpenActivate] = useState<IOpen>({
    open: false,
    driver: null,
  });

  const showBan = (driver: IDriver) => setOpenBan({ open: true, driver });
  const showActivate = (driver: IDriver) =>
    setOpenActivate({ open: true, driver });

  const handleCloseBan = () => setOpenBan({ open: false, driver: null });
  const handleCloseActivate = () =>
    setOpenActivate({ open: false, driver: null });

  const showDelete = (driver: IDriver) => setOpenDelete({ open: true, driver });
  const handleCloseDelete = () => setOpenDelete({ open: false, driver: null });

  return (
    <DriverAlertContext.Provider
      value={{
        showDelete,
        showActivate,
        showBan,
      }}
    >
      {openDelete.driver && (
        <DeleteModal
          open={openDelete.open}
          driver={openDelete.driver}
          handleClose={handleCloseDelete}
        />
      )}
      {openBan.driver && (
        <BanModal
          open={openBan.open}
          driver={openBan.driver}
          handleClose={handleCloseBan}
        />
      )}

      {openActivate.driver && (
        <ActivateModal
          open={openActivate.open}
          driver={openActivate.driver}
          handleClose={handleCloseActivate}
        />
      )}
      {children}
    </DriverAlertContext.Provider>
  );
}
